import { sound } from '@pixi/sound';
import { PixiBase } from '../../core/abstraction/PixiBase';

const soundTypes = {
  mainBackground: 'SOUND_TYPES_MAIN_BACKGROUND',
  bonusPreBonusBackground: 'SOUND_TYPES_BONUS_PRE_BONUS_BACKGROUND',
  elementMove: 'SOUND_TYPES_ELEMENT_MOVE',
  spin: 'SOUND_TYPES_SPIN',
  wheelSpin: 'SOUND_TYPES_WHEEL_SPIN',
  wheelSpin2: 'SOUND_TYPES_WHEEL_SPIN_2',
  wheelSpin3: 'SOUND_TYPES_WHEEL_SPIN_3',
  wheelStopOnCrystal: 'SOUND_TYPES_WHEEL_STOP_ON_CRYSTAL',
  betAmountChange: 'SOUND_TYPES_BET_AMOUNT_CHANGE',
  singleClick: 'SOUND_TYPES_SINGLE_CLICK',
  moveSound: 'MOVE_SOUND',
  wheelSound: 'WHEEL_SOUND',
};

const soundResources = [
  { name: soundTypes.mainBackground, path: 'sounds/background_main.wav' },
  { name: soundTypes.bonusPreBonusBackground, path: 'sounds/background_prebonus_and_bonus.mp3' },
  { name: soundTypes.elementMove, path: 'sounds/element_move.mp3' },
  { name: soundTypes.spin, path: 'sounds/spin.mp3' },
  { name: soundTypes.wheelSound, path: 'sounds/wheel_sound.mp3' },
  { name: soundTypes.wheelStopOnCrystal, path: 'sounds/wheel_stop_on_crystal.mp3' },
  { name: soundTypes.singleClick, path: 'sounds/singleClick.wav' },
  { name: soundTypes.betAmountChange, path: 'sounds/bet_amount_change.mp3' },
  { name: soundTypes.moveSound, path: 'sounds/move_sound.mp3' },
];

class PixiSoundService extends PixiBase {
  constructor() {
    super();
    this.loader = new this.PIXI.Loader();
    this.state = new Set();
    this._texture = {};
  }

  async init() {
    soundResources.forEach(({name, path}) => {
      sound.add(name, path)
    })
    return this.loadResource(soundResources, this.loader);
  }

  mute() {
    sound.muteAll();
  }

  unmute() {
    sound.unmuteAll();
  }

  play(name, loop = false) {
    this._texture[name] = true;
    sound.play(name, { loop });
  }

  stop(name) {
    if (this._texture[name]) {
      this._texture[name] = false;
      sound.stop(name);
      if (this.state.has(name)) {
        this.state.delete(name);
      }
    }
  }

  playMainSceneBackground() {
    this.stop(soundTypes.bonusPreBonusBackground);
    this.play(soundTypes.mainBackground, true);
  }

  playBonusAndPreBonusBackground() {
    if (!this.state.has(soundTypes.bonusPreBonusBackground)) {
      this.state.add(soundTypes.bonusPreBonusBackground);
      this.stop(soundTypes.mainBackground);
      this.play(soundTypes.bonusPreBonusBackground, true);
    }
  }

  playPreBonusSceneBackground() {
    this.playBonusAndPreBonusBackground();
  }

  playBonusSceneBackground() {
    this.playBonusAndPreBonusBackground();
  }

  playWheel() {
    this.play(soundTypes.wheelSound, false);
  }

  stopWheel() {
    this.stop(soundTypes.wheelSound);
  }

  playWheelStopOnCrystal() {
    this.stopWheel();
    this.play(soundTypes.wheelStopOnCrystal);
  }

  playSpin() {
    this.play(soundTypes.spin);
  }

  playBetAmountChange() {
    this.play(soundTypes.betAmountChange);
  }

  playSpinCountChange() {
    this.play(soundTypes.betAmountChange);
  }

  playSingleClick() {
    this.play(soundTypes.singleClick);
  }

  playControlItemClick() {
    this.playSingleClick();
  }

  playOddCrystalClick() {
    this.playSingleClick();
  }

  playBuyBonusClick() {
    this.playSingleClick();
  }

  playBuyBonusCloseClick() {
    this.playSingleClick();
  }

  playBuyBonusBuyClick() {
    this.playSingleClick();
  }

  playElementMove() {
    this.play(soundTypes.elementMove);
  }

  playMoveSound() {
    this.play(soundTypes.moveSound);
  }
}

export const soundService = new PixiSoundService();
